import { defineSlotRecipe } from '@chakra-ui/react';

import { assetImageSlots } from '../slots';

export default defineSlotRecipe({
  slots: assetImageSlots,
  defaultVariants: {
    size: 'md',
  },
  variants: {
    size: {
      sm: {
        container: {
          h: 16,
          w: 24,
          px: 0,
          border: '1px solid',
          borderColor: 'border.brandedDefault',
        },
        assetIcon: {
          boxSize: 6,
        },
        assetCaption: {
          textStyle: 'xs',
        },
        fallbackIcon: {
          boxSize: 4.5,
        },
        fallbackCaption: {
          mt: 0.5,
          textStyle: 'xs',
        },
      },
      md: {
        container: {
          h: 28,
          w: 44,
          px: 9,
        },
        assetIcon: {
          boxSize: 14,
        },
        assetCaption: {
          mt: 0.5,
          textStyle: 'sm',
        },
        fallbackIcon: {
          boxSize: 6,
        },
        fallbackCaption: {
          mt: 0.5,
          textStyle: 'sm',
        },
      },
    },
  },
  base: {
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      borderRadius: 'lg',
      gap: 0,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    },
    image: {
      borderRadius: 'lg',
      objectFit: 'cover',
      h: 'full',
      w: 'full',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    assetIcon: {
      color: 'brandPrimary.solid',
    },
    assetCaption: {
      color: 'fg.muted',
      fontWeight: 'normal',
    },
    fallbackIcon: {
      color: 'fg.subtle',
    },
    fallbackCaption: {
      color: 'fg.muted',
      fontWeight: 'normal',
    },
  },
});
